import { NavLink } from "react-router-dom";
import Breadcumbs from "../../components/Breadcumbs";
import DataFetcherTemplate from "../../hooks/fetchTemplate";
import { motion } from "framer-motion";
import BlockRightImage from "../../components/BlockRightImage";
import Accordion from "../../components/Accordion";
import Block4Columns from "../../components/Block4ColumnsText";
import ModalFixed from "../../components/ModalFixed";
import BlockLeftImage from "../../components/BlockLeftImage";
import BlockImageCabecera from "../../components/BlockImageCabecera";
import ImageGallery from "../../components/ImageGallery";
import BannerGeneral from "../../components/BannerGeneral";
import evaluacion from "../../img/logosingles/evaluacion.png";
import certificado from "../../img/logosingles/certificado.png";
import titulos from "../../img/logosingles/titulos.png";
import instituciones from "../../img/logosingles/instituciones.png";
import { ChevronDown } from "lucide-react";

function SegundaLengua() {
  const items = [
    {
      href: "#examen",
      img: evaluacion,
      text: "Rendir un examen de ubicación",
    },
    {
      href: "#certificados",
      img: certificado,
      text: "Reconocer certificados de otras instituciones",
    },
    {
      href: "#titulos",
      img: titulos,
      text: "Homologar títulos de tercer y cuarto nivel",
    },
    {
      href: "#instituciones",
      img: instituciones,
      text: "Prepararte en instituciones externas aliadas a la UTPL",
    },
  ];

  const DataDisplay = ({ data }) => (
    <>
      <div>
        {data.map((item, index) => (
          <div key={index}>
            <div className="margin">
              <BlockImageCabecera
                src={item.field_portada}
                title={
                  <>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: item.field_texto_portada,
                      }}
                    />
                  </>
                }
              ></BlockImageCabecera>
            </div>
            <div className="bluebg">
              <Breadcumbs
                content={
                  <>
                    <NavLink to="/segunda-lengua">Segunda Lengua</NavLink>
                  </>
                }
              ></Breadcumbs>

              <center>
                <div className="layout8">
                  <div className="width500">
                    <div
                      dangerouslySetInnerHTML={{ __html: item.field_bloque1 }}
                    />
                  </div>
                </div>
              </center>

              <div className="max-w-6xl m-auto py-12">
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
                  {items.map((item, index) => (
                    <a
                      key={index}
                      href={item.href}
                      className="group flex flex-col items-center text-center 
                       bg-white/95 backdrop-blur-md 
                       rounded-2xl p-6 
                       shadow-lg hover:shadow-xl
                       transition-all duration-300 
                       hover:-translate-y-2"
                    >
                      {/* Icono */}
                      <div
                        className="w-20 h-20 flex items-center justify-center 
                            bg-blue-50 rounded-full group-hover:bg-blue-100 transition"
                      >
                        <img
                          src={item.img}
                          alt="utpl"
                          className="object-contain w-12 h-12"
                        />
                      </div>

                      {/* Texto */}
                      <span className="text-m text-[#004270] font-semibold leading-snug">
                        {item.text}
                      </span>

                      {/* Flecha animada */}
                      <motion.div
                        initial={{ y: 8, opacity: 0.6 }}
                        animate={{ y: [8, 0, 8], opacity: [0.6, 1, 0.6] }}
                        transition={{
                          duration: 1.2,
                          repeat: Infinity,
                          ease: "easeInOut",
                        }}
                        className="text-blue-600"
                      >
                        <ChevronDown size={22} />
                      </motion.div>
                    </a>
                  ))}
                </div>
              </div>
            </div>

            <div id="examen">
              <div className="relative">
                <BlockLeftImage
                  src={item.field_imagen2}
                  content={
                    <>
                      <div className="icon20">
                        <img src={evaluacion} alt="utpl"></img>
                      </div>
                      <div
                        dangerouslySetInnerHTML={{ __html: item.field_bloque2 }}
                      />
                    </>
                  }
                ></BlockLeftImage>
                <ModalFixed
                  color="#4e975b"
                  title="Proceso de inscripción 📝"
                  content={
                    <div className="width400">
                      <ImageGallery
                        gallery={item.field_gallery1}
                      ></ImageGallery>
                    </div>
                  }
                ></ModalFixed>
              </div>
              <div className="relative text-column">
                <div className="content">
                  <div className="layout8 padding2 ">
                    <div
                      dangerouslySetInnerHTML={{ __html: item.field_bloque3 }}
                    />
                  </div>
                </div>

                <ModalFixed
                  color="#4e975b"
                  title="Proceso de registro ✔"
                  content={
                    <div className="width400">
                      <ImageGallery
                        gallery={item.field_gallery2}
                      ></ImageGallery>
                    </div>
                  }
                ></ModalFixed>
              </div>
            </div>
            <div className="relative">
              <div className="graybg" id="certificados">
                <div className="relative">
                  <BlockRightImage
                    src={item.field_imagen4}
                    content={
                      <>
                        {" "}
                        <div className="icon20">
                          <img src={certificado} alt="utpl"></img>
                        </div>
                        <div
                          dangerouslySetInnerHTML={{
                            __html: item.field_bloque4,
                          }}
                        />
                        <Accordion
                          title="Certificados de Lenguas Ancestrales y Lenguas de Señas"
                          content={
                            <>
                              <div
                                dangerouslySetInnerHTML={{
                                  __html: item.field_bloque5,
                                }}
                              />
                            </>
                          }
                        ></Accordion>
                        <Accordion
                          title="Certificados nacionales e internacionales"
                          content={
                            <>
                              <div
                                dangerouslySetInnerHTML={{
                                  __html: item.field_bloque6,
                                }}
                              />
                            </>
                          }
                        ></Accordion>
                        <Accordion
                          title="Certificados de instituciones de educación superior"
                          content={
                            <>
                              <div
                                dangerouslySetInnerHTML={{
                                  __html: item.field_bloque7,
                                }}
                              />
                            </>
                          }
                        ></Accordion>
                        <br></br>
                        <a
                          className="button"
                          href=" https://studentssb-prod.srv.utpl.edu.ec/StudentSelfService/ssb/studentCommonDashboard"
                        >
                          Solicitar homologacion
                        </a>
                      </>
                    }
                  ></BlockRightImage>
                  <ModalFixed
                    color="#6f56c1"
                    title="Proceso de homologación ✍🏼️"
                    content={
                      <div className="width400">
                        <ImageGallery
                          gallery={item.field_gallery3}
                        ></ImageGallery>
                      </div>
                    }
                  ></ModalFixed>{" "}
                </div>
              </div>
            </div>

            <div id="titulos" className="relative">
              <BlockLeftImage
                src={item.field_imagen8}
                content={
                  <>
                    <div className="icon20">
                      <img src={titulos} alt="utpl"></img>

                      <div
                        dangerouslySetInnerHTML={{
                          __html: item.field_bloque8,
                        }}
                      />
                    </div>
                  </>
                }
              ></BlockLeftImage>
              <ModalFixed
                color="#186150"
                title="Proceso de homologación ✍🏼️"
                content={
                  <div className="width400">
                    {" "}
                    <ImageGallery gallery={item.field_gallery4}></ImageGallery>
                  </div>
                }
              ></ModalFixed>{" "}
            </div>

            <div className="relative">
              <div id="instituciones" className="relative graybg ">
                <div className="layout8 padding">
                  <div className="icon20">
                    <img src={instituciones} alt="utpl"></img>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: item.field_bloque9,
                      }}
                    />
                  </div>

                  <div className=" layout8 ">
                    <Accordion
                      title="Idioma Inglés"
                      content={
                        <div className="icon100">
                          <div>
                            <BlockLeftImage
                              src={item.field_imagen10}
                              content={
                                <>
                                  <div
                                    dangerouslySetInnerHTML={{
                                      __html: item.field_bloque10,
                                    }}
                                  />
                                </>
                              }
                            ></BlockLeftImage>
                          </div>

                          <div>
                            <BlockRightImage
                              src={item.field_imagen11}
                              content={
                                <>
                                  <div
                                    dangerouslySetInnerHTML={{
                                      __html: item.field_bloque11,
                                    }}
                                  />
                                </>
                              }
                            ></BlockRightImage>
                            <div>
                              <BlockLeftImage
                                src={item.field_imagen12}
                                content={
                                  <>
                                    <div
                                      dangerouslySetInnerHTML={{
                                        __html: item.field_bloque12,
                                      }}
                                    />
                                  </>
                                }
                              ></BlockLeftImage>
                            </div>
                          </div>
                        </div>
                      }
                    ></Accordion>
                    <Accordion
                      title="Idioma Frances"
                      content={
                        <div className="icon100">
                          <BlockLeftImage
                            src={item.field_imagen13}
                            content={
                              <>
                                <div
                                  dangerouslySetInnerHTML={{
                                    __html: item.field_bloque13,
                                  }}
                                />
                              </>
                            }
                          ></BlockLeftImage>
                        </div>
                      }
                    ></Accordion>
                    <Accordion
                      title="Idioma Italiano"
                      content={
                        <div className="icon100">
                          <BlockLeftImage
                            src={item.field_imagen14}
                            content={
                              <>
                                <div
                                  dangerouslySetInnerHTML={{
                                    __html: item.field_bloque14,
                                  }}
                                />
                              </>
                            }
                          ></BlockLeftImage>
                        </div>
                      }
                    ></Accordion>

                    <Accordion
                      title="Idioma Portugués"
                      content={
                        <div className="icon100">
                          <BlockLeftImage
                            src={item.field_imagen15}
                            content={
                              <>
                                <div
                                  dangerouslySetInnerHTML={{
                                    __html: item.field_bloque15,
                                  }}
                                />
                              </>
                            }
                          ></BlockLeftImage>
                        </div>
                      }
                    ></Accordion>
                    <Accordion
                      title="Idioma Alemán"
                      content={
                        <div className="icon100">
                          <BlockLeftImage
                            src={item.field_imagen16}
                            content={
                              <>
                                <div
                                  dangerouslySetInnerHTML={{
                                    __html: item.field_bloque16,
                                  }}
                                />
                              </>
                            }
                          ></BlockLeftImage>
                        </div>
                      }
                    ></Accordion>
                  </div>
                </div>
              </div>
              <ModalFixed
                color="#3F51B5"
                title="Proceso de registro ✔"
                content={
                  <div className="width400">
                    <ImageGallery gallery={item.field_gallery2}></ImageGallery>
                  </div>
                }
              ></ModalFixed>
            </div>
          </div>
        ))}
      </div>
    </>
  );

  return (
    <>
      <DataFetcherTemplate url="https://utpl.edu.ec/carreras/services/servicio-segundalengua.json">
        {(data) => <DataDisplay data={data} />}
      </DataFetcherTemplate>
      <BannerGeneral></BannerGeneral>
    </>
  );
}

export default SegundaLengua;
